import { getUserAgent } from './internal';
export const isIE11 = () => getUserAgent().includes('trident/');
export const isEdge = () => getUserAgent().includes('edge/');
export const isFirefox = () => getUserAgent().includes('firefox');
export const isSafari = () => getUserAgent().includes('safari/') && !getUserAgent().includes('chrome/') && !isEdge();